import React from 'react';
import './TaisaCoreLogo.css';

/**
 * TaisaCore Logo Component
 *
 * The logo has a black background built-in.
 * Always place in black/dark sections or use withBackground={true}
 *
 * @param {string} size - 'tiny' | 'small' | 'medium' | 'large' | 'xlarge' | 'hero'
 * @param {boolean} animated - Enable glow animation (default: true)
 * @param {boolean} withBackground - Add black background container (default: true)
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 * @param {function} onClick - Click handler
 */
const TaisaCoreLogo = ({
  size = 'medium',
  animated = true,
  withBackground = true,
  className = '',
  style = {},
  onClick = null
}) => {
  // Size configurations (height in pixels)
  const sizes = {
    tiny: 32,
    small: 48,
    medium: 80,
    large: 120,
    xlarge: 180,
    hero: 280
  };

  const height = sizes[size] || sizes.medium;

  // Use process.env.PUBLIC_URL for correct path in Create React App
  const logoImage = `${process.env.PUBLIC_URL}/images/taisacore-logo-original.png`;

  return (
    <div
      className={`taisacore-logo ${size} ${animated ? 'animated' : ''} ${withBackground ? 'with-bg' : ''} ${className}`}
      style={style}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <img
        src={logoImage}
        alt="TaisaCore"
        style={{ height: `${height}px`, width: 'auto' }}
        className="logo-image"
        draggable={false}
        onError={(e) => {
          console.error('Logo failed to load:', logoImage);
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
};

export default TaisaCoreLogo;
